import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AssetImageDimensions, getAssetImageDimensions } from '../../utils/asset-image-dimensions';
import { LoadersModule } from '../loaders/loaders.module';

@Component({
    standalone: true,
    selector: 'app-image-loader',
    templateUrl: './image-loader.component.html',
    styleUrls: ['./image-loader.component.scss'],
    imports: [LoadersModule, CommonModule, NgOptimizedImage],
})
export class ImageLoaderComponent {
    public loading = true;
    public failed: boolean;

    @Input() src: string;
    @Input() title = '';
    @Input() alt = '';
    @Input() width = 'auto';
    @Input() height = 'auto';
    @Input() color = 'auto';
    @Input() priority = false;
    @Input() loadingMode: 'lazy' | 'eager' | 'auto' = 'lazy';
    @Input() intrinsicWidth: number | null = null;
    @Input() intrinsicHeight: number | null = null;

    constructor() {}

    public get imageDimensions(): AssetImageDimensions | null {
        if (this.intrinsicWidth && this.intrinsicHeight) {
            return {
                width: this.intrinsicWidth,
                height: this.intrinsicHeight,
            };
        }
        return getAssetImageDimensions(this.src);
    }

    public get loadingBehavior(): 'lazy' | 'eager' | 'auto' {
        return this.priority ? 'eager' : this.loadingMode;
    }

    onLoad(): void {
        this.loading = false;
        this.failed = false;
    }

    onError(): void {
        this.loading = false;
        this.failed = true;
    }
}
